import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {
  @Input() title: string = '';
  @Input() svgIcon: SafeHtml  = ''; // SVG content as string
  @Input() active = false;
  @Output() selected = new EventEmitter<void>();

  onSelect() {
    this.selected.emit(); // Notify parent component
  }

}
